module.exports = __webpack_public_path__ + "img/guide2.262a9f90.png";